<template>
  <v-row class="ml-0">
    <v-col cols="6" class="pa-0">
      <product-alerts
        v-if="canSeeAlerts && product.filteredAlerts.length"
        :key="product._id"
        :alerts="product.filteredAlerts"
      />
    </v-col>
    <v-col cols="6" :class="isAgGridProductListEnabled ? 'promotion-col' : 'pa-0'">
      <tooltip
        v-if="itemHasUpcomingPromotion(product)"
        :value="getFreezePromotionTooltip(product)"
        :position="position"
      >
        <v-icon v-once> $promotion-pr </v-icon>
      </tooltip>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { yearMonthDayFormat } from '@enums/date-formats';
import { useStickersPromotion } from '@enums/feature-flags';
import featureFlagsMixin from '../../../mixins/featureFlags';

export default {
  mixins: [featureFlagsMixin],

  props: {
    product: {
      type: Object,
      required: true,
    },
    position: {
      type: String,
      default: 'top-right',
    },
  },

  computed: {
    ...mapGetters('context', ['canSeeAlerts']),
    ...mapGetters('gridView', ['isAgGridProductListEnabled', 'itemHasUpcomingPromotion']),

    childPromotionEnabled() {
      return this.isFeatureFlagEnabled(useStickersPromotion);
    },
  },

  methods: {
    getFreezePromotionTooltip(item) {
      let date = get(item.upcomingPromotion, 'effectiveDate', '9999-12-31');
      if (this.childPromotionEnabled) {
        const childPromotionStarts = Object.values(
          get(item, 'childPromotions.upcomingPromotion', {})
        ).map(child => child.effectiveDate);
        date = moment
          .min([...childPromotionStarts, date].map(x => moment(x)))
          .format(yearMonthDayFormat);
      }
      const formattedDate = this.formatLocalisedDate(date);
      return `${this.$t('gridView.tooltips.hasUpcomingPromotion')} ${formattedDate}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.promotion-col {
  padding: 3px 0 0 0;
}
</style>
